/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";

const ModuleDefinition = {
  name: "Filter Options",
  entityName: "cancellationPolicyConfiguration",
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section

  translation: {
    translated: false,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterOptionTranslations",
  },
  sorting: {
    property: "filterOptionPosition",
    sortable: false,
  },
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "May Cancel online",
      },
      {
        fieldName: "maxRelease",
        displayName: "Max Release",
        widget: "daysRenderer",
        showForDuration: [0, 1, 2, 3],
      },
      {
        fieldName: "minRelease",
        displayName: "Min release",
        widget: "daysRenderer",
        showForDuration: [0, 1, 2, 3],
      },
      {
        fieldName: "type",
        displayName: "Penalty Type",
        widget: "arrayPropertyRenderer",
        searchCriteria: "type",
        fieldSelector: {
          FIX_AMOUNT: "Fixed amount",
          PERCENTAGE: "Percentage",
          CHARGE_FIRST_NIGHT: "First night",
        },
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "cancelOnline",
        displayName: "May cancel online",
        widget: "checkbox",
      },
      {
        fieldName: "maxRelease",
        displayName: "Max Release",
        widget: "cancellationRange",
        helpText: "This field represents the number of days from which the restriction applies.",
      },
      {
        fieldName: "minRelease",
        displayName: "Min release",
        widget: "cancellationRange",
        helpText:
          "This field represents the number of days before check-in after which the restriction is no longer applied.",
      },
      {
        fieldName: "type",
        displayName: "Penalty type",
        widget: "selector",
        optionDisplay: {
          FIX_AMOUNT: {
            label: "Fixed amount",
          },
          PERCENTAGE: {
            label: "Percentage",
          },
          CHARGE_FIRST_NIGHT: {
            label: "First night",
          },
        },
        defaultValue: "FIX_AMOUNT",
      },
      {
        fieldName: "penalty",
        displayName: "Amount",
        widget: "input",
        visible: ({ formValues }) => formValues.type !== "CHARGE_FIRST_NIGHT",
      },
    ],
  },
  validation: {
    "minRelease.days": {
      type: "Number",
      constraints: {
        compare: {
          logic: "isLesser",
          than: ["maxRelease"],
          message: "^Max release must be greater than min release.",
          valueType: "number",
        },
      },
      relatedFields: ["maxRelease"],
    },
    maxRelease: {
      type: "Number",
      constraints: {
        compare: {
          logic: "isGreater",
          than: ["minRelease.days"],
          message: "^Max release must be greater than min release.",
          valueType: "number",
        },
      },
      relatedFields: ["minRelease.days"],
    },
    type: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["FIX_AMOUNT", "PERCENTAGE", "CHARGE_FIRST_NIGHT"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "FIX_AMOUNT",
    },
    penalty: {
      type: "Number",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    cancelOnline: {
      type: "Boolean",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
